export default __webpack_public_path__ + "static/media/InProgress.45afa4d0.svg";